module.exports = __webpack_public_path__ + "img/tick_icon_color.5b36a6af.svg";